import { Grid, IconButton, Menu, MenuItem } from '@material-ui/core';
import { DateRange, Description, MoreHoriz, School, Block } from '@material-ui/icons';
import RoomIcon from '@material-ui/icons/Room';
import {
  checkIfPostuleTraining,
  getSavedCandidature,
  postuleTraining,
  unSavedTraining,
} from '@webapps/business';
import {
  Button,
  PaginationNumbers,
  useAuth,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarCompany from 'components/Avatar/AvatarCompany';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import { ROUTES_PATH } from 'config/constants';
import { useEffect, useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

const SchoolFavoris = ({ handleFormationLength }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();
  const { push } = useRouter();

  const [page, setPage] = useState(1);

  const {
    status: load,
    data: { content: savedFormations = [], totalElements } = {},
    refetch,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isFetching,
  } = useQuery(getSavedCandidature, {
    key: ['savedFormation', page],
    variables: { id: idUser, page: page - 1, size: 12 },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    handleFormationLength(totalElements);
  }, [totalElements]);

  const goToMyMap = () => {
    push(ROUTES_PATH.MYMAP, { params: { id: idUser } });
  };

  return (
    <div>
      <Grid
        container
        style={
          savedFormations?.length === 0
            ? {
              display: 'flex',
              justifyContent: 'center',
              padding: spacing(2.5),
              backgroundColor: '#F3F7FF',
              borderRadius: 10,
            }
            : {
              display: 'flex',
              backgroundColor: '#F3F7FF',
              borderRadius: 10,
              padding: spacing(2.5, 0, 0, 2.5),
              height: '100%'
            }
        }
      >
        {!savedFormations?.length ? (
          <Grid
            container
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Grid
              item
              className={css({
                backgroundColor: '#FFFFFF',
                borderRadius: 12,
                padding: '30.0px',
                '@media screen and (max-width: 768px)': {
                  padding: '20px',
                },
              })}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <h1
                  className={cx(css({
                    textAlign: 'center',
                    margin: '0px 0px 30px 0px',
                  }), global.title)}
                >
                  {' '}
                  Commencez à enregistrer les offres de formation
                </h1>
                <p style={{ textAlign: 'center', margin: '5px' }}>
                  {' '}
                  1. Accédez à la recherche d'offres de formation de nos écoles partenaires.
                </p>
                <p style={{ textAlign: 'center', margin: '5px' }}>
                  {' '}
                  2. Triez les offres de formation selon vos critères de recherche et enregistrez les en un clic.
                </p>
                <p
                  style={{ textAlign: 'center', margin: '5px 5px 30px 5px' }}
                >
                  {' '}
                  3. Retrouvez facilement les offres de formation pour y candidatez dès que vous êtes prêt !
                </p>
                <Button
                  className={classes.btn}
                  color="primary"
                  variant="contained"
                  onClick={goToMyMap}
                  disableElevation={true}
                >
                  Rechercher des offres
                </Button>
              </div>
            </Grid>
          </Grid>
        ) : (
          <Grid container>
            {savedFormations?.map(({ saveDate, training }, index) => (
              <FavortieCard
                index={index}
                training={training}
                saveDate={saveDate}
                refetch={refetch}
              />
            ))}
          </Grid>
        )}
      </Grid>
      <PaginationNumbers
        onChange={handlePaginationChange}
        page={page}
        pageCount={12}
        totalCount={totalElements}
      />
    </div>
  );
};

const FavortieCard = ({training, saveDate, index, refetch}) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();
  const { addToast } = useToast();

  const [page, setPage] = useState(1);
  const [idFormation, setIdFormation] = useState();
  const [anchorCandid, setAnchorCandid] = useState(null);

  const openCandid = Boolean(anchorCandid);
  const { push } = useRouter();
  const handleClick = (event) => {
    setAnchorCandid(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorCandid(null);
  };

  const { data: checkPostule = {}, refetch: refetchPostule } = useQuery(
    checkIfPostuleTraining,
    {
      key: ['checkPostuleTraining'] + idUser + training?.id,
      variables: { idApplicant: idUser, idTraining: training?.id },
    }
  );

  const {
    isLoading: isLoadingPostuleTraining,
    isSuccess: isSuccessPostule,
    mutateAsync: mutatePostuleTraining,
  } = useMutation(postuleTraining);

  const {
    isLoading: isLoadingDelete,
    isSuccess: isSuccessDelete,
    mutateAsync: mutateDeleteSavedTraining,
  } = useMutation(unSavedTraining);

  const postuTraining = async ({ idTraining }) => {
    setIdFormation(idTraining);
    await mutatePostuleTraining({
      data: {
        applicant: {
          id: idUser,
        },
        training: {
          id: idTraining,
        },
      },
    });
  };

  const goToSchool = (idSchool) => {
    push(ROUTES_PATH.SCHOOL_VITRINE, { params: { id: idSchool } });
  };

  const deleteSavedTraining = async ({ idTraining }) => {
    await mutateDeleteSavedTraining({
      idApplicant: idUser,
      idTraining,
    });
  };

  useEffect(async () => {
    if (isSuccessPostule) {
      await mutateDeleteSavedTraining({
        idApplicant: idUser,
        idTraining: idFormation,
      });
      refetchPostule;
    }
  }, [isSuccessPostule]);

  useEffect(async () => {
    if (isSuccessDelete) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
    }
    refetch;
  }, [isSuccessDelete]);

  const date = new Date();

  return (
    <Grid
      item
      xs={12}
      md={4}
      lg={3}
      key={index}
      style={{ padding: spacing(0, 2.5, 2.5, 0) }}
    >
      <Grid
        item
        className={css({
          display: 'flex',
          justifyContent: 'space-between',
          backgroundColor: '#fff',
          borderRadius: 10,
          padding: spacing(2.5),
        })}
      >
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          })}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex' }}>
              <AvatarCompany
                height={60}
                idCompany={training?.school?.id}
                name={training?.shcool?.name}
                variant="circular"
                width={60}
              />
              <div style={{ display: 'flex', marginLeft: "8px", flexDirection: 'column', justifyContent: 'center' }}>
                <div className={cx(global.title, classes.block)}> {training?.label} </div>
                <div className={cx(global.infoText, classes.name)}>
                <div style={{marginRight: '8px'}}>{training?.school?.name}</div>
                <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />
                </div>
              </div>
            </div>
            <IconButton
              onClick={handleClick}
              size="small"
              aria-controls={openCandid ? 'candidature-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openCandid ? 'true' : undefined}
              style={{
                alignSelf: 'baseline',
                borderRadius: '20px',
                border: '1px solid #C0D9FF',
                backgroundColor: '#F3F7FF',
                width: '26px',
                display: 'flex',
                justifyContent: 'center',
                height: '26px',
                alignItems: 'center',
                cursor: 'pointer',
              }}
            >
              <MoreHoriz style={{ color: '#5A6DA1', fontSize: '15.00px' }} />
            </IconButton>
          </div>

          <div className={classes.divInfos}>
            <div className={cx(global.infoText, classes.address)}>
              <School className={global.infoIcon} />
              {training?.degree?.label.slice(0, 3)}
            </div>
            <div className={cx(global.infoText, classes.address)}>
              <Description className={global.infoIcon} />
              {training?.trainingType?.label}
            </div>
            {training?.school?.address?.city && (
              <div className={cx(global.infoText, classes.address)}>
                <RoomIcon className={global.infoIcon} />
                {training?.school?.address?.cityCode}{' '}
                {training?.school?.address?.city}
              </div>
            )}
            <div className={cx(global.infoText, classes.address)}>
              <DateRange className={global.infoIcon} />
              <div>
                <FormattedDate
                  day="numeric"
                  month="numeric"
                  value={saveDate?.saveDate}
                  year="numeric"
                />
              </div>
            </div>
            <div className={css({ display: 'flex', marginTop: spacing(2) })}>
              {checkPostule ? (
                <Button
                  disabled
                  variant="outlined"
                >
                  Déjà postulé
                </Button>
              ) : new Date(training?.applicationStartDate?.split('T')[0]) <=
                  date &&
                new Date(training?.applicationClosingDate?.split('T')[0]) >=
                  date ? (
                <Button
                  color="primary"
                  disabled={isLoadingPostuleTraining || isLoadingDelete}
                  onClick={() => postuTraining({ idTraining: training?.id })}
                  variant="contained"
                >
                  Postuler
                </Button>
              ) : (
                <Button
                  color="primary"
                  style={{
                    backgroundColor: '#E0E0E0',
                    color: '#A6A6A6',
                  }}
                  disabled
                  startIcon={<Block />}
                  variant="contained"
                >
                  Formation fermée
                </Button>
              )}
            </div>
          </div>
        </div>
        <Menu
          anchorEl={anchorCandid}
          id="candidature-menu"
          open={openCandid}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{ elevation: 2 }}
          transformOrigin={{ horizontal: 'left', vertical: -50 }}
          anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
        >
          <MenuItem
            disableRipple
            disableFocusRipple
            onClick={() => goToSchool(training.training?.school?.id)}
          >
            Voir la vitrine
          </MenuItem>
          {/* <MenuItem>
        <Link className={css({ textDecoration: 'none', display: 'flex', alignItems: 'center', color: '#000000DE' })}
          to='#'>
          Voir l'annonce
        </Link></MenuItem> */}
          <MenuItem
            disableRipple
            disableFocusRipple
            onClick={() =>
              deleteSavedTraining({ idTraining: training.training?.id })
            }
          >
            Retirer des favoris
          </MenuItem>
        </Menu>
      </Grid>
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  container: {
    padding: spacing(3),
    borderRadius: 10,
    border: '1px solid #E8E8E8',
    marginTop: spacing(3),
    '&:first-child': { marginTop: 0 },
  },
  profilName: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  avatar: {
    height: 50,
    width: 50,
  },
  name: {
    color: '#152652',
    display: 'flex',
    alignItems: 'center',
    marginTop: 10,
  },
  timer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    marginTop: spacing(0.5),
  },
  block: {
    display: 'flex',
    width: '100%',
  },
  timer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  noElement: {
    lineHeight: '110%',
  },
  divInfos: {
    marginTop: spacing(1),
    '@media only screen and (max-width:768px)': {
      margin: 0,
    },
  },
});

export default SchoolFavoris;
